import React, { createContext, useState, useContext, useEffect } from 'react';
import { login as apiLogin, verifyToken } from '../api';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      try {
        const response = await verifyToken();
        if (response.data.valid) {
          setIsAuthenticated(true);
          setAdmin({ email: response.data.email });
        } else {
          localStorage.removeItem('admin_token');
        }
      } catch (error) {
        localStorage.removeItem('admin_token');
      }
    }
    setIsLoading(false);
  };

  const login = async (credentials) => {
    try {
      const response = await apiLogin(credentials);
      const { access_token } = response.data;
      localStorage.setItem('admin_token', access_token);
      setIsAuthenticated(true);
      setAdmin({ email: credentials.email });
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Login failed'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setIsAuthenticated(false);
    setAdmin(null);
  };

  return (
    <AdminContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        admin,
        login,
        logout
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
